// GENERATED FILE. DO NOT EDIT BY HAND.
//
// Ground truth:    Quick_Scan_2_1_Discovery_Model__6000_.xlsx, Answer Here!B5:D21
//                  sha256 e21271d349041dc6abca302173eea46159f72387b1bbf366fbd2766faa42f585
//                  read via fixtures/answer-here-B5D21.json; the workbook itself
//                  is never committed, see scripts/extract-workbook-words.mjs
// Also checked at: 17Q_Discovery_Build_Spec.md (sections 6 and 7)
// Regenerate:      npm run gen:questions
// Verify:          npm run gen:check
//
// These 51 word strings are FROZEN. The Quick Scan 2.1 workbook compares them
// with an exact string match (=IF($E$5=B5,5,IF($F$5=B5,1,3))). A near-match does
// not error. It silently scores 3 for every word in the row and produces a wrong
// profile that nobody notices. Do not sentence-case, re-hyphenate, trim, or tidy
// anything below.
//
// Question 5 word 1 is "Self willed" with NO hyphen. That is correct. Spec section 4.

import type { Question } from './types.ts';

/** Spec section 6. Bump only alongside a new question set; never mutate history. */
export const INSTRUMENT_VERSION = "QS2.1-17Q-v1";

/**
 * Provenance for the export's Meta sheet: the exact workbook these words were
 * read from. If an operator's workbook hashes differently, it may be a different
 * question set and the export must not be pasted into it.
 */
export const SOURCE_WORKBOOK = "Quick_Scan_2_1_Discovery_Model__6000_.xlsx";
export const SOURCE_WORKBOOK_SHA256 = "e21271d349041dc6abca302173eea46159f72387b1bbf366fbd2766faa42f585";

/** The workbook's own wording, from Answer Here!A2, first sentence. */
export const RESPONDENT_INSTRUCTION = "For each question, choose the word that is MOST like you and the one that is LEAST like you.";

/** QS position (1..17) to source 46Q question number. Spec section 6 source map. */
export const QS_TO_Q46: readonly number[] = [5, 6, 8, 16, 17, 21, 22, 23, 26, 27, 31, 33, 35, 36, 37, 38, 40];

/** The frozen 17-question word list, in presentation order. */
export const QUESTIONS: readonly Question[] = [
  {
    qsPosition: 1,
    sourceQ46: 5,
    words: ["Solution driven", "Accurate", "Excitable"],
    wordNums: [13, 14, 15],
  },
  {
    qsPosition: 2,
    sourceQ46: 6,
    words: ["Influencing", "Brave", "Concerned"],
    wordNums: [16, 17, 18],
  },
  {
    qsPosition: 3,
    sourceQ46: 8,
    words: ["Prepares in advance", "Outgoing", "Concerned for others"],
    wordNums: [22, 23, 24],
  },
  {
    qsPosition: 4,
    sourceQ46: 16,
    words: ["Straightforward communicator", "Develops new methods", "Courteous"],
    wordNums: [46, 47, 48],
  },
  {
    qsPosition: 5,
    sourceQ46: 17,
    words: ["Self willed", "Friendly nature", "Connects well with others"],
    wordNums: [49, 50, 51],
  },
  {
    qsPosition: 6,
    sourceQ46: 21,
    words: ["Structured", "Amusing", "Original"],
    wordNums: [61, 62, 63],
  },
  {
    qsPosition: 7,
    sourceQ46: 22,
    words: ["Sets the agenda", "Networks", "Idea orientated"],
    wordNums: [64, 65, 66],
  },
  {
    qsPosition: 8,
    sourceQ46: 23,
    words: ["Assumes control", "Pioneering", "Assists others"],
    wordNums: [67, 68, 69],
  },
  {
    qsPosition: 9,
    sourceQ46: 26,
    words: ["Seeks out risks", "Intelligent", "Empathetic"],
    wordNums: [76, 77, 78],
  },
  {
    qsPosition: 10,
    sourceQ46: 27,
    words: ["Imagines new possibilities", "Sets big goals", "Examines details"],
    wordNums: [79, 80, 81],
  },
  {
    qsPosition: 11,
    sourceQ46: 31,
    words: ["Agreeable", "Pays attention to detail", "Confident approach"],
    wordNums: [91, 92, 93],
  },
  {
    qsPosition: 12,
    sourceQ46: 33,
    words: ["Accepts challenges", "Engaging", "Investigates new ideas"],
    wordNums: [97, 98, 99],
  },
  {
    qsPosition: 13,
    sourceQ46: 35,
    words: ["Lenient", "Expressive", "Risk taker"],
    wordNums: [103, 104, 105],
  },
  {
    qsPosition: 14,
    sourceQ46: 36,
    words: ["Skillful in designing", "Fits in with others", "Daring"],
    wordNums: [106, 107, 108],
  },
  {
    qsPosition: 15,
    sourceQ46: 37,
    words: ["Energetic", "Particular", "Wields authority"],
    wordNums: [109, 110, 111],
  },
  {
    qsPosition: 16,
    sourceQ46: 38,
    words: ["Tolerates losses", "Communicative", "Diligent"],
    wordNums: [112, 113, 114],
  },
  {
    qsPosition: 17,
    sourceQ46: 40,
    words: ["Enjoys talking", "Success driven", "Sensitive to others"],
    wordNums: [118, 119, 120],
  },
];
